import { render } from "./PartnerOportun.vue?vue&type=template&id=1063f1b1"
import script from "./PartnerOportun.vue?vue&type=script&lang=js"
export * from "./PartnerOportun.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__